module.exports = __webpack_public_path__ + "static/media/arab04.87fc350b.wav";